const VID_KEY = "app_vid";
const EXCLUDED = ["/admin", "/console", "/outreach", "/login"];

function visitorId() {
  try {
    let v = localStorage.getItem(VID_KEY);
    if (!v) {
      const bytes = new Uint8Array(16);
      (window.crypto || {}).getRandomValues ? window.crypto.getRandomValues(bytes) : bytes.forEach((_, i) => { bytes[i] = Math.floor(Math.random() * 256); });
      v = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
      localStorage.setItem(VID_KEY, v);
    }
    return v;
  } catch {
    return "anon-" + Math.random().toString(36).slice(2, 14);
  }
}

export function track(event, path = window.location.pathname, meta = undefined) {
  try {
    if (typeof navigator !== "undefined" && navigator.webdriver) return;
    const clean = (path || "/").split("?")[0];
    if (EXCLUDED.some((p) => clean === p || clean.startsWith(p + "/"))) return;
    // Dedupe identical events fired within 1s (React StrictMode double-invokes effects in dev).
    const sig = `${event}|${clean}`;
    const now = Date.now();
    if (window.__v2eLastTrack && window.__v2eLastTrack.sig === sig && now - window.__v2eLastTrack.at < 1000) return;
    window.__v2eLastTrack = { sig, at: now };
    const body = JSON.stringify({
      event,
      path: clean,
      referrer: event === "pageview" ? document.referrer || null : null,
      vid: visitorId(),
      width: window.innerWidth,
      meta: meta || null,
    });
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/track`;
    fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  } catch {
    /* fire-and-forget */
  }
}
